import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../../Components/Form";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IListarComprovantesUsuarioRequest } from "../../../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import { listarTipoAtividadesController } from "../../../../../Controllers/Geral/TipoAtividades";
import { useUserInfor } from "../../../../../Context/User";
import { ListarUsuariosVendasController } from "../../../../../Controllers/Vendas/Usuario/UsuarioController";
import { IPropsTableChange } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { FormProvider, useForm } from "react-hook-form";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import moment from "moment";

interface IAgendaAtividadesFiltro {
    handleFilterFormSubmit(formData: IListarComprovantesUsuarioRequest): void;
    filter: IListarComprovantesUsuarioRequest | undefined;
    handleSearch(searchValue: string, newState: IPropsTableChange): void;
    filtroInicial: IListarComprovantesUsuarioRequest;
    FILTRO_AGENDA_ATIVIDADES: string | null;
}

export default function AgendaAtividadesFiltro({
    handleFilterFormSubmit,
    filter,
    filtroInicial,
    FILTRO_AGENDA_ATIVIDADES,
}: IAgendaAtividadesFiltro) {
    const { UserInfor } = useUserInfor();
    const { id } = useModuloInfo();

    const formMethods = useForm();

    const { reset } = formMethods;

    const { value: lstTipoAtividade, loading: lstTipoAtividadeLoading } =
        useAsyncEffect(async () => {
            if (id) return listarTipoAtividadesController(id, "");
        }, [id]);

    return (
        <StickyToolbar active={!!FILTRO_AGENDA_ATIVIDADES}>
            <OrSpinner loading={lstTipoAtividadeLoading} spinner="capys">
                <FormProvider {...formMethods}>
                    <UnForm handleSubmit={handleFilterFormSubmit} usingContext>
                        <div className="row">
                            <div className="col-6">
                                <label>Data Inicial</label>
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={
                                        filter?.DT_DATA_IN
                                            ? moment(filter.DT_DATA_IN).format(
                                                  "YYYY-MM-DD"
                                              )
                                            : ""
                                    }
                                    name="DT_DATA_IN"
                                />
                            </div>
                            <div className="col-6">
                                <label>Data Final</label>
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={
                                        filter?.DT_DATA_FN
                                            ? moment(filter.DT_DATA_FN).format(
                                                  "YYYY-MM-DD"
                                              )
                                            : ""
                                    }
                                    name="DT_DATA_FN"
                                />
                            </div>
                        </div>
                        <UnForm.Input
                            label="Protocolo"
                            name="ID_CASO"
                            type={"text"}
                            defaultValue={filter?.ID_CASO}
                        />

                        <UnForm.Select
                            label="Status"
                            name="DS_STATUS"
                            defaultValue={filter?.DS_STATUS}
                            className="form-control"
                        >
                            <option value={""}></option>
                            <option value={"planejada"}>Planejada</option>
                            <option value={"executada"}>Executada</option>
                            <option value={"atrasada"}>Atrasada</option>
                        </UnForm.Select>

                        <UnForm.Select
                            label="Tipo Atividade"
                            name="ID_TIPO_ATIVIDADE"
                            defaultValue={filter?.ID_TIPO_ATIVIDADE}
                            className="form-control"
                        >
                            <option value=""></option>
                            {lstTipoAtividade?.map((tipoAtividade) => (
                                <option
                                    key={tipoAtividade.ID_TIPO_ATIVIDADE}
                                    value={tipoAtividade.ID_TIPO_ATIVIDADE}
                                >
                                    {tipoAtividade.DS_TIPO_ATIVIDADE}
                                </option>
                            ))}
                        </UnForm.Select>

                        <UnForm.Input
                            label="Cliente"
                            name="DS_CLIENTE"
                            defaultValue={filter?.DS_CLIENTE}
                            className="form-control"
                        />

                        {(UserInfor.ID_PERFIL_USUARIO === 3 ||
                            UserInfor.ID_PERFIL_USUARIO === 6) && (
                            <UnForm.LazySelect
                                label="Visualizar Atividades de"
                                name="ID_USUARIO_REQUEST"
                                controller={ListarUsuariosVendasController}
                                getDS={(usuario) => usuario.DS_NOME}
                                getKeyValue={(usuario) => usuario.ID_USUARIO}
                                className="form-control"
                            >
                                <option value=""></option>
                            </UnForm.LazySelect>
                        )}

                        <UnForm.SubmitButton
                            className="w-100"
                            wrapperClassName="w-100 d-flex align-items-end justify-content-start mt-3"
                            icon={faFilter}
                            color="dark"
                            outline
                        >
                            Filtrar
                        </UnForm.SubmitButton>
                        <button
                            type="button"
                            onClick={() => {
                                window.sessionStorage.removeItem(
                                    `FILTRO_AGENDA_ATIVIDADES_${id}`
                                );
                                reset(filtroInicial);
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </UnForm>
                </FormProvider>
            </OrSpinner>
        </StickyToolbar>
    );
}
